import { Card, CardNoteSide } from '@lingoping/core';
import { StorageManager } from '../storage/index.js';

/**
 * Saves the learner's note for one side of a card (an empty text removes it) and returns the card
 * as it is stored now, or null when the card no longer exists. Only the note is changed, on the
 * card as it is saved now, so a review or a picture that arrived meanwhile is kept.
 */
export async function saveCardNote(
  cardId: string,
  side: CardNoteSide,
  text: string
): Promise<Card | null> {
  return StorageManager.setCardNote(cardId, side, text);
}
